const SESSION_TOKEN_KEY = "session_token";
const SESSION_TOKEN_EXPIRY_KEY = "session_token_expiry";

/**
 * Fired whenever the session is established or torn down (OTP verify, sign out, expiry
 * reset). useSubscriptionFlow's hasValidSession listens for this; EventWatchButton also
 * listens so a Watch button re-evaluates once the user finishes signing in via a
 * different button's SubscribeModal on the same page.
 */
export const SESSION_CHANGED_EVENT = "session-changed";
export const notifySessionChange = () => window.dispatchEvent(new Event(SESSION_CHANGED_EVENT));

/**
 * Single source of truth for the subscription session, stored in sessionStorage by the
 * OTP verification flow (see useSubscriptionFlow.handleVerifyOTP). Centralised here so
 * every consumer (SubscribeModal, ManageSubscriptionsModal, useSubscriptionFlow itself)
 * agrees on what "valid" means -- a prior inline copy in useSubscriptionFlow's
 * handleEmailSubmit compared the expiry the wrong way round.
 */
export const getSessionToken = () => sessionStorage.getItem(SESSION_TOKEN_KEY);

export const isSessionValid = () => {
    const expiry = sessionStorage.getItem(SESSION_TOKEN_EXPIRY_KEY);
    return !!expiry && Date.now() <= parseInt(expiry, 10);
};

export const setSession = (sessionToken, expiresAtSeconds) => {
    sessionStorage.setItem(SESSION_TOKEN_KEY, sessionToken);
    sessionStorage.setItem(SESSION_TOKEN_EXPIRY_KEY, expiresAtSeconds * 1000);
};

export const clearSession = () => {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
    sessionStorage.removeItem(SESSION_TOKEN_EXPIRY_KEY);
};

